import { render } from "./MoneyRequestModal.vue?vue&type=template&id=3e24f4e0&scoped=true&ts=true"
import script from "./MoneyRequestModal.vue?vue&type=script&lang=ts"
export * from "./MoneyRequestModal.vue?vue&type=script&lang=ts"

import "./MoneyRequestModal.vue?vue&type=style&index=0&id=3e24f4e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e24f4e0"]])

export default __exports__